<h4 class="title">Client Status Marking</h4>
<div class="card-box">
    <div class="row" style="padding: 0px 0px 23px 10px;">
        <div class="col-md-6">
            <h5 class="form-lable">Client:</h5>
            <p-dropdown [options]="types" [(ngModel)]="cli_type" placeholder="Select" optionLabel="y"
                [showClear]="true"></p-dropdown>
        </div>
        <div class="col-md-6">
            <h5 class="form-lable">Status:</h5>
            <p-dropdown [options]="types" [(ngModel)]="cli_type" placeholder="Select" optionLabel="y"
                [showClear]="true"></p-dropdown>
        </div>
        <div class="col-md-3">
            <h5 class="form-lable">Start date:</h5>
            <p-calendar [showIcon]="true" inputId="icon"></p-calendar>
        </div>
        <div class="col-md-3">
            <h5 class="form-lable">End date:</h5>
            <p-calendar [showIcon]="true" inputId="icon"></p-calendar>
        </div>
        <div class="col-md-6">
            <h5 class="form-lable">Remarks:</h5>
            <textarea rows="3" cols="30" pInputTextarea [(ngModel)]="address"></textarea>
        </div>
        <div class="col-md-6">
            <h5 class="form-lable">Attachment:</h5>
            <input type="file">

        </div>
        <div class="col-md-6 mt-20">
            <button type="button" class="btn btn-primary">Update</button>
            <!-- <button type="button" class="btn btn-primary btn-bg-blue" (click)="cancel()">Cancel</button> -->
        </div>
        <div class="col-md-12 mt-20">
            <table class="spec-table">
                <thead>
                    <!-- <th>S.No</th> -->
                    <th>Client</th>
                    <th>Status</th>
                    <th>Attachment</th>
                    <th>Start date</th>
                    <th>End date</th>
                </thead>
                <tbody>
                    <!-- <tr *ngFor="let arr of contactarray ; let i= index;">
                    <td>{{i+1}}</td>
                    <td>{{arr.con_name}}</td>
                    <td>{{arr.con_role}}</td>
                    <td>{{arr.con_pone}}</td>
                    <td><i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"
                            (click)="remove_contact(i)"></i></td>
                </tr> -->
                </tbody>
            </table>
        </div>

    </div>
</div>